import request from '@/utils/request_python'

export function getUcapFeatures() {
  return request({
    url: `ucap/caracteristicas`,
    method: 'get'
  })
}

export function setUcapFeatures(caracteristicasData) {
  return request({
    url: 'ucap/update/caracteristica',
    method: 'post',
    data: caracteristicasData
  })
}

export function getTemplateUcap() {
  return request({
    url: 'ucap/download-template',
    method: 'get',
    responseType: 'blob'
  })
}

export function uploadTemplateUcap(empr_id, usua_id, formData) {
  return request({
    url: 'ucap/upload-template',
    method: 'post',
    data: formData,
    params: {
      empr_id: empr_id,
      usua_id: usua_id
    },
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getInventory(empr_id, fecha_corte) {
  return request({
    url: 'sync/inventario/ucap/masivo',
    method: 'get',
    responseType: 'blob',
    params: {
      empr_id: empr_id,
      fecha_corte: fecha_corte
    }
  })
}
